import Drawer from './src/drawer2.mjs';
export { drawerEmits, drawerProps } from './src/drawer.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElDrawer = withInstall(Drawer);

export { ElDrawer, ElDrawer as default };
//# sourceMappingURL=index.mjs.map
